// extracted by mini-css-extract-plugin
module.exports = {"partner":"set-password_partner__33MaB","email":"set-password_email__32kqJ","success":"set-password_success__eZ8Cy"};